<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>


    <template> 
      <v-toolbar flat>
        <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-fire</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
          <v-dialog v-model="dialogsharelink" max-width="90%">
            <v-card>
              <v-card-title>
                <v-card-title><span class="text-h6">GET API DATA</span></v-card-title>
                
              </v-card-title>
              <v-card-text height="auto">
                <v-data-table 
                  :headers="headerdatadialogsharelink"
                  :items="datadialogsharelink" 
                  :items-per-page="100"
                  :hide-default-footer="true"
                  :disable-sort="true"
                  flat
                  >
                  
                  <template v-slot:[`item.url`]="{ item }">
                    <v-text >{{ decodeURIComponent(item.url) }}</v-text>
                  </template>

          
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn small class="mx-2" color="primary"   :href=item.url target="_blank">
                      <v-icon>mdi-launch</v-icon> GET LINK
                    </v-btn>
                  </template>
                  
                </v-data-table>
              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 180px;" rounded outlined dense @click="close">
                  Close 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

      </v-toolbar>
    </template>
      <v-row class="ma-6">
        <v-col cols="12" sm="6" md="3">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startdate"
                label="Start Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                >
              </v-text-field>
            </template>
            <v-date-picker v-model="startdate" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
    <v-spacer></v-spacer>
    <v-col cols="12" sm="6" md="3">
      <v-menu ref="menu2" v-model="menu2"  :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="enddate"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
            >
            </v-text-field>
          </template>
          <v-date-picker v-model="enddate" no-title scrollable >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu2 = false" >
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menu2.save(date)" >
              OK
            </v-btn>
          </v-date-picker>
      </v-menu>
    </v-col>
    
    <v-col  cols="12" sm="6" md="3">
        <v-btn
          dense
          color="#439EDF"
          dark
          rounded
          @click="search()"
        > search
          <v-icon class="ml-2">mdi-magnify</v-icon>
        </v-btn>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
      >
    </v-col>
    <v-col
      cols="12"
      sm="6"
      md="3"
      >
    </v-col>
    <v-spacer></v-spacer>
  </v-row>
    <v-data-table 
    :loading="loadtable"
    loading-text="Loading data..."
    :headers="headers" 
    :items="datatable" 
    sort-by="paramid"
     class="elevation-1"
    :pagination.sync="pagination" 
    :server-items-length="totalNumberOfItems" 
    :footer-props="{
      'items-per-page-options': listSize
    }"
    @update:options="paginate"

    >

    <!-- :items-per-page="lengthpage"
    :server-items-length="totalNumberOfItems" 
    :pagination.sync="pagination" 
    :items-per-page-options ="listSize" -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small class="mx-2" color="primary"  @click="get_history_apis(item.TRX_ID)">
          GET API HIT <v-icon>mdi-share</v-icon> 
        </v-btn> 
      </template>
    </v-data-table>
        <Notification  ref="alert"></Notification>
      </div>
      
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex';
import { decryptionData } from '@/components/utils/utils.js';
import Notification from  '@/components/Notification';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      rolename: ['ADMIN', 'USER', 'REVIEWER'],
      userstatus: ['non active', 'active', 'disabled'],
      online: ['true', 'false'],
      startdate: new Date().toISOString().substr(0, 10),
      enddate: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      dialogsharelink: false,
      
      datadialogsharelink: "",
      
      headerdatadialogsharelink: [
        { text: 'Type', value: 'type' },
        { text: 'Url', value: 'url', sortable: false },
        { text: 'ACTIONS' , value: 'actions', sortable: false }
      ],
      decodedToken: null,
      headers: [
        { text: 'ACTIONS', value: 'actions', sortable: false },
        { text: 'MODULE NAME', value: 'NAME_MODULE' },
        { text: 'REQ NAME', value: 'REQ_NAME' },
        { text: 'START DATE HIT', value: 'START_DATE_HIT_API' },
        { text: 'LONG TIME', value: 'END_DATE_HIT_API' },
        { text: 'RESPONSE STATUS', value: 'RESPONSE_STATUS' },
      ],
      datatable: [],
      // pagenation 
      loadtable: true,
      totalNumberOfItems: 10,
      listSize: [10, 25, 50, 100],
      pagination:
        {
          limit: 10,
          page:  0,
        },
    // end pagenation 



      editedIndex: -1,
      editedItem: {
        // actiondate: '2022-04-19 21:26:00',
        // username: 'kbi',
        // ip: '192.168.31.170',
        // action: 'Access Set BO Doc Manager',
        // note: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36 Edg/100.0.1185.44',
      },
      defaultItem: {
        // actiondate: '2022-04-19 21:26:00',
        // username: 'kbi',
        // ip: '192.168.31.170',
        // action: 'Access Set BO Doc Manager',
        // note: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.127 Safari/537.36 Edg/100.0.1185.44',
      },
    }),
    computed: {
      
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'New User' : 'Edit User'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      search () {

      // this.options.page = 0;
      // this.options.itemsPerPage = 10; 

        this.pagination.page = 0;
        this.pagination.limit = 10;
        
        this.initialize() 
      },
      paginate (val)
      {
        this.pagination.limit =val.itemsPerPage
        this.pagination.page =val.page-1
        this.initialize() 
      },
      initialize () {
        this.loadtable = true;
        axios.get("api-log?page_v=" +  this.pagination.page + "&limit_v=" +  this.pagination.limit+ "&startdate=" + this.startdate+ "&enddate=" +  this.enddate,
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            this.datatable = [];
            const data = decryptionData(response.data.token);
            this.totalNumberOfItems =data.totalRows
            this.datatable =  data.result;
            // end loading 
            setTimeout(() =>{
              // this.loading = false
              this.loadtable = false;

            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                 
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      get_history_apis (trx_id) {
          if(this.datatable.length > 0){
            for (let i = 0; i <  this.datatable.length; i++) {  
              if(this.datatable[i].TRX_ID ==trx_id){
                this.datadialogsharelink = (JSON.parse((this.datatable[i].REQUEST_XML)));
                // console.log(this.datatable[i].REQUEST_XML);
              }
            }
          }
          
          
        this.dialogsharelink = true
      },
      close () {
        this.dialogsharelink = false
      },
      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.table[this.editedIndex], this.editedItem)
        } else {
          this.table.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>